import React, { useEffect, useState, useRef } from 'react';
import page2Slogan from '@/assets/images/page2Slogan.png';
import item2 from '@/assets/images/item2.png';
import item3 from '@/assets/images/item3.png';


import styles from './index.less';


const Page = (props) => {
  return (
    <section className={styles.wrap} data-active={props.show}>
      <img src={page2Slogan} className={`${styles.slogan} ${props.show?styles.anSlogan:''}`}/>
      <img src={item2} className={styles.item2} />
      <img src={item3} className={styles.item3} />
      
    </section>
  )
}

export default Page;